<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-下单送券-添加
    -->
    <el-dialog
    title="添加下单送券"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="活动名称" :label-width="formLabelWidth" prop="active_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.active_name" placeholder="请输入活动名称"></el-input>
      </el-form-item>
      <el-form-item label="满类型" :label-width="formLabelWidth">
        <div>
          <el-radio v-model="form.full_type" :label="1">满金额</el-radio>
          <el-radio v-model="form.full_type" :label="2">满件数</el-radio>
        </div>
      </el-form-item>
      <el-form-item label="满值" :label-width="formLabelWidth" prop="full_value" :rules="[{required: true,message: ' '}]">
        <el-input type="number" :precision="1" :step="1" :min="0" placeholder="请输入满值" v-model="form.full_value"></el-input>
      </el-form-item>



      <div class="common-form">赠送优惠券</div>   
      <el-form-item label="奖励优惠券" >
          <el-input class="max-w460" placeholder="点击选择奖励优惠券" 
          v-model="form.coupon_name" :disabled="true"></el-input>
          <el-button icon="el-icon-link" @click="addCoupon()">选择优惠券</el-button>
        </el-form-item>
        <div>秒杀活动产生的订单不参与赠送优惠券</div>


    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

    <GetCoupon v-if="open_addc" :open_add="open_addc" @closeDialog="closeProductDialogFunc($event)">选择优惠券弹出层</GetCoupon>
  </div>
</el-dialog>
  
</template>

<script>
import OarcouponApi from '@/api/oarcoupon.js';
import GetCoupon from '@/components/coupon/GetCoupon';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
export default {
  components: {

     /*图片上传*/
     Upload: Upload,
     Categoryas,
     draggable,
     GetCoupon,
  },
  data() {
    return {
              /*左边长度*/
              formLabelWidth: '120px',
         /*是否上传图片*/
         isupload: false,
 
      /*form表单数据*/
      form: {
        active_name:"",
        full_type:1,
        full_value:"",
        coupon_name:"",
        coupon_id:0,
  
      },
      loading: false,
      /*验证规则*/
      rules: {
        active_name: [{ required: true, message: '请输入下单送券名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,

      isProductUpload:false,
      code:"album",

      isproduct: false,
      /*产品去重*/
      excludeIds: [],
      islist:true,

      open_addc:false,

    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
     /*添加优惠券*/
     addCoupon() {
      this.open_addc = true;
    },
    /*关闭弹窗*/
    closeProductDialogFunc(e) {
      this.open_addc = e.openDialog;

      if (e.type == 'success') {
         this.form.coupon_id = e.params.coupon_id;
        this.form.coupon_name = e.params.name;
      }
    },
 
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_sku_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },

     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
  
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          OarcouponApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
     /*打开上传图片*/
     openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/oarcoupon/index/part/add.vue